module.exports = __webpack_public_path__ + "files/fc0bd2ce86993a3c13d7ebc50b4ee9f1.png";